import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/context/AuthContext';

export function useLocaleSync() {
  const { user } = useAuth();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (user?.settings?.locale && user.settings.locale !== i18n.language) {
      i18n.changeLanguage(user.settings.locale);
    }
  }, [user?.settings?.locale, i18n]);

  return {
    currentLocale: i18n.language,
    changeLanguage: i18n.changeLanguage.bind(i18n),
  };
}